import { KoBreadcrumb, KoButton, KoForm, KoLoader, KoModal, KoToast } from 'packages';
import { supportAPI } from 'pages/support/tickets/support.service';
import TaskCrud from 'pages/workspace/process/development/task/crud';
import { DevelopmentAPI } from 'pages/workspace/process/development/development.service';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams, useSearchParams } from 'react-router-dom';
import { getTicketBreadCrumb } from 'shared/commonConstants';
import ReadonlyCurd from 'shared/components/tickettable/readonlyCurd';
import { BrowseAPI } from '../browse.service';
import styles from './preview.module.scss';
import { useSelector } from 'react-redux';
import { getCurrentAssignees } from 'shared/store/currentAssigneesSlice';
import { getHolidays } from 'shared/store/holidaysSlice';


const TaskById = () => {
  const [searchParams] = useSearchParams();
  const currentAssignees = useSelector(state => state?.currentAssignees);
  const from = searchParams.get('from');
  const [ticketDetails, setTicketDetails] = useState();
  const [breadCurmbs, setBreadCrumbs] = useState();
  const [loading, setLoading] = useState(false);
  const [currentWorkspace, setCurrentWorkspace] = useState();
  const [profile, setProfile] = useState(currentAssignees);
  let { accountId, workspaceId, ticketId } = useParams();
  const dispatch = useDispatch();
  const [form] = KoForm.useForm();

  useEffect(() => {
    dispatch(getHolidays());
    if (workspaceId)
      dispatch(getCurrentAssignees(workspaceId));
    getWorkspaceById(workspaceId);
    getTickets(ticketId);
  }, [workspaceId]);


  useEffect(() => {
    setProfile(currentAssignees);
  }, [currentAssignees]);

  useEffect(() => {
    if (ticketId && from === 'support') {
      setLoading(true);
      supportAPI.getIssueByIdPublic(ticketId).then(
        (data) => {
          setTicketDetails(data['issue']);
          let crums = getTicketBreadCrumb(data?.issue, currentWorkspace);
          setBreadCrumbs(crums);
          setLoading(false);
        },
        (err) => {
          setLoading(false);
        }
      );
    }

  }, [ticketId]);

  const getWorkspaceById = (workspaceId) => {
    DevelopmentAPI.getWorkspaceById(workspaceId).then(
      (data) => {
        setCurrentWorkspace(data['project']);

      },
      (err) => {
      }
    );
  };

  const getTickets = (id) => {
    setLoading(true);
    setTicketDetails();
    BrowseAPI.getIssuesById(id, accountId, workspaceId).then(
      (data) => {
        setLoading(false);
        setTicketDetails(data?.issue);
        let crums = getTicketBreadCrumb(data?.issue, currentWorkspace);
        setBreadCrumbs(crums);
    
      },
      (err) => {
        setLoading(false);
        if (err.error === "Unauthorized") {
          const currentPage = window.location.href;
          window.location.href = `/?redirect=${encodeURIComponent(currentPage)}`;
        }
      }
    );
  };


  const handleFinish = (values => {
    setLoading(true);
    DevelopmentAPI.createOrUpdateIssues(values, ticketDetails?.ticketId, workspaceId).then(
      (data) => {
        setLoading(false);
        getTickets(ticketId);
        form.resetFields();
        KoToast.success(`Ticket updated successfully`);
      },
      (err) => {
        setLoading(false);
      }
    );
  });


  return (
    <div className={styles.wrapper}>
      {loading && <KoLoader />}
      <div className={styles.header}>
        {breadCurmbs ? <KoBreadcrumb  items={breadCurmbs} /> : null}
      </div>
      <KoModal
        title={
          breadCurmbs
            ? <KoBreadcrumb items={breadCurmbs} />
            : (ticketDetails?.ticketDetails)
              ? `Update Issue ${(ticketDetails?.ticketId).toUpperCase()}`
              : `Create Issue` }
        centered
        afterClose={() => { setBreadCrumbs(); }}
        open={true}
        handleOk={() => { window.close(); }}
        onClose={() => { window.close(); }}
        width={'95vw'}
        height={'95vh'}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => { window.close(); form.resetFields(); }} />,
          from !== 'support' && <KoButton key='create' type='primary' label={ticketDetails?.ticketId ? `Update` : `Create`}
            onClick={() => form.submit()} />
        ]}
      >
        {from !== 'support' && profile ? <TaskCrud form={form} getIssueById={getTickets} handleFinish={handleFinish} initialValues={ticketDetails} profile={profile} /> :
          <ReadonlyCurd issue={ticketDetails} />}

      </KoModal>
   
    </div >
  );
};

export default TaskById;
